import { Messages } from '../../../../codegen/Localize';
import { IGroupInfo } from '../../../../ts/models/IGroupInfo';
import { syncAdGroups } from '../../../actions/spaces/GroupMenuActions';
import { SessionUserSelectors } from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const SyncActiveDirectoryGroupsAction: IEntityAction<IGroupInfo, {}> = {
  name: EntityActionNames.SynchronizeGroups,
  translateName: Messages.synchronize_action,
  isVisible: (targetItems: IGroupInfo[], state: AppState) => {
    return targetItems.length >= 1
      && SessionUserSelectors.canManageUsers(state)
      && hasADGroups(targetItems);
  },
  isClickable: () => true,
  createReduxAction: (targetItems: IGroupInfo[]) => syncAdGroups(targetItems)
};

function hasADGroups(groups: IGroupInfo[]): boolean {
  const result = groups.filter(group => isActiveDirectoryGroup(group)).length;
  return result >= 1;
}

function isActiveDirectoryGroup(group: IGroupInfo): boolean {
  return (group.domainName && group.domainName !== 'local');
}
